module.exports = __webpack_public_path__ + "static/media/property-people-mobiles.97cc739e.jpg";